import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { connect } from "react-redux"
import { planOptions } from 'applications/Plan/planConfig'
import { changeApplication } from 'actions/rootActions'
import { setRedirectedAction, setUpgradeDismissed } from 'actions/planActions'
import { setDoneAction } from 'actions/intercomActions'
import { DEFAULT_APP_NAME } from 'modules/constants'
import { useLocation, useNavigate } from 'react-router-dom'

@connect((store) => ({
  currentApp: store.root.applicationId,
  previousApplicationId: store.root.previousApplicationId,
  subscription: store.plan.subscription,
  mimicStatus: store.mimic.mimic.status,
  loginFromChannel: store.root.loginFromChannel,
}), {
  changeApplication,
  setRedirectedAction,
  setUpgradeDismissed,
  setDoneAction,
})

class ActionModal extends React.Component {

  state = {
    action: null,
  }

  getPlanAction = (subscription, isLite, subscriptionActive, isFreeUser, isBusinessGated) => {
    const { plan_status: planStatus = {}, plans: currentPlans, status } = subscription
    const planOptionConfigs = planOptions(this.props.loginFromChannel)
    const currentPlan = planOptionConfigs.find(option => option.product === (currentPlans[0] || {}).product)
    const nextPlan = planOptionConfigs.find(option => option.product === (planStatus.nextPlan || 'Entrepreneur'))

    if (isBusinessGated) {
      const businessPlan = planOptionConfigs.find(option => option.product === 'Business')
      return {
        targetApp: 'plan',
        targetViewIndex: 0,
        planOption: {
          priceMonth: (planStatus.businessPrice || 0),
          priceYear: Math.round((planStatus.businessPrice || 0) * 9.6),
          priceTwoYear: Math.round((planStatus.businessPrice || 0) * 18),
          priceThreeYear: Math.round((planStatus.businessPrice || 0) * 25.2),
          ...businessPlan,
        },
        ctaText: 'Upgrade Now',
        message: (
          <div className="Business">
            <p>This feature requires the Business plan. Upgrade to unlock advanced analytics:</p>
            {
              businessPlan.description.map((line, lineIndex) => (
                <div className="pricing-description" key={`line-${lineIndex}`}>
                  {
                    line.map((words, wordsIndex) => (
                      <span key={`line-${lineIndex}-${wordsIndex}`}>
                        {words.startsWith('b_') ? <b>{words.substr(2)}</b> : words}
                      </span>
                    ))
                  }
                </div>
              ))
            }
          </div>
        ),
        pageTitle: 'Upgrade to Business',
        modalTitle: 'Upgrade to Unlock This Feature',
      }
    }

    if (isFreeUser) {
      const entrepreneurPlan = nextPlan || planOptionConfigs.find(option => option.product === 'Entrepreneur')
      return {
        targetApp: 'plan',
        targetViewIndex: 0,
        planOption: entrepreneurPlan,
        ctaText: 'Upgrade Now',
        message: (
          <div className="Entrepreneur">
            <p>Upgrade your plan to unlock powerful analytics and reporting features:</p>
            {
              entrepreneurPlan.description.map((line, lineIndex) => (
                <div className="pricing-description" key={`line-${lineIndex}`}>
                  {
                    line.map((words, wordsIndex) => (
                      <span key={`line-${lineIndex}-${wordsIndex}`}>
                        {words.startsWith('b_') ? <b>{words.substr(2)}</b> : words}
                      </span>
                    ))
                  }
                </div>
              ))
            }
          </div>
        ),
        pageTitle: 'Upgrade Your Plan',
        modalTitle: 'Upgrade to Unlock This Feature',
      }
    }

    if (!subscriptionActive) {
      const statusMessage = status === 'active' ? 
        `Please kindly notice that your trial has expired.` :
        `Please kindly notice that your subscription is suspended.`
      return {
        ...((nextPlan.product === 'Business' && !planStatus.businessPrice) ? {
          targetUrl: 'https://www.payhelm.com/contact/',
          ctaText: 'Contact Us',
        } : {
          targetApp: 'plan',
          targetViewIndex: 0,
          planOption: nextPlan,
          ctaText: 'Subscribe Now',
        }),
        message: (
          <div>
            <p>{statusMessage}</p>
            <p>{`Set your plan/payment options to keep getting updated metrics/charts.`}</p>
          </div>
        ),
        pageTitle: 'Thank you for trying PayHelm > Set Plan/Payments',
        modalTitle: 'Thank you for trying PayHelm',
      }
    }
    if (planStatus.creditCardRequired) {
      return {
        targetApp: 'plan',
        targetViewIndex: 1,
        planOption: nextPlan,
        message: (
          <div>
            <p>{`Please kindly notice that your payment options are currently missing.`}</p>
            <p>{`Set them to keep getting updated metrics/charts.`}</p>
          </div>
        ),
        ctaText: 'Update Now',
        pageTitle: 'Thank you for using PayHelm > Set Payments',
        modalTitle: 'Thank you for using PayHelm',
      }
    }
    return null
  }

  componentDidUpdate(prevProps) {
    const { plan_status: prevPlanStatus = {} } = prevProps.subscription
    const { plan_status: planStatus = {} } = this.props.subscription
    if (
      prevPlanStatus.trialExpired !== planStatus.trialExpired ||
      prevPlanStatus.creditCardRequired !== planStatus.creditCardRequired ||
      prevProps.isFreeUser !== this.props.isFreeUser ||
      prevProps.isBusinessGated !== this.props.isBusinessGated
    ) {
      const action = this.getPlanAction(this.props.subscription, this.props.isLite, this.props.subscriptionActive, this.props.isFreeUser, this.props.isBusinessGated)
      this.setState({ action })
    }
  }

  componentDidMount() {
    const { subscription, isLite, isFreeUser, isBusinessGated } = this.props
    if (subscription) {
      const action = this.getPlanAction(subscription, isLite, this.props.subscriptionActive, isFreeUser, isBusinessGated)
      this.setState({ action })
    }
  }

  render() {
    const { 
      currentApp, previousApplicationId, changeApplication,
      setRedirectedAction, setUpgradeDismissed, setDoneAction, 
      mimicStatus, show = false, backdropClassName = '', allowContinue = false, continueTo, onClose
    } = this.props
    const { action } = this.state
    if (!action || !show) return null
    return (
      <Modal 
        show={true} 
        backdropClassName={backdropClassName} 
        onHide={allowContinue ? () => {
          setDoneAction({ type: 'upgrade_dimissed' })
          if (!allowContinue) {
            changeApplication(currentApp, previousApplicationId)
            const { navigate } = this.props
            navigate(`/${previousApplicationId || 'dashboard'}`)
          }
          if (onClose) {
            onClose()
          }
        } : null}
        className="plan-modal"
      >
        <title>{`${action.pageTitle} - ${DEFAULT_APP_NAME} Analytics & Intelligence`}</title>
        <Modal.Header {...(allowContinue ? { closeButton: true } : {})}>
          <Modal.Title>{action.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {action.message}
        </Modal.Body>
        <Modal.Footer>
          <div className="left">
            {
              (mimicStatus || allowContinue) ? (
                <div className="inline-block mr1">
                  <Button
                    onClick={() => {
                      setUpgradeDismissed(true)
                      const { navigate, location } = this.props
                      if (!mimicStatus) {
                        setDoneAction({ type: 'upgrade_dimissed' })
                      }
                      if (location.pathname === '/action') {
                        navigate(`/dashboard`, { replace: true })
                      }
                      if (onClose) {
                        onClose()
                      }
                  }}>
                    {'Continue'}
                  </Button>
                </div>
              ) : null
            }
            <div className="float-right">
              <LinkContainer to={action.targetApp ? '/plan' : '/action'}>
                <Button
                  variant="primary"
                  onClick={() => {
                    if (action.targetApp) {
                      changeApplication(currentApp, action.targetApp)
                      setRedirectedAction(action)
                    }
                    else if (action.targetUrl) {
                      window.open(action.targetUrl, '_blank')
                      return
                    }
                    if (onClose) {
                      onClose()
                    }
                }}>
                  {action.ctaText}
                </Button>
              </LinkContainer>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

function ActionModalWithRouter(props) {
  const location = useLocation()
  const navigate = useNavigate()
  return <ActionModal {...props} location={location} navigate={navigate} />
}

export default ActionModalWithRouter